import { defineComponent, ref, computed, inject, watch } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { generateElementId } from '../../helpers/generators.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MarketSelector",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true },
    showCurrency: { type: Boolean, required: false, default: true },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ["store-error", "data-load", "market-selection"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const selected = ref(null);
    const marketSelectorId = generateElementId("fds-market-selector-");
    const isSelectDisabled = computed(() => {
      var _a;
      return props.disabled || ((_a = storeData.value) != null ? _a : []).length <= 1;
    });
    const componentInputs = computed(() => ({
      id: props.id,
      language: props.locale
    }));
    const localizationSupport = useLocalizationSupport(props, { translator: inject("translator") });
    const { translate, textFormat } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, isLoadingStoreData } = storeModule;
    const onMarketChange = () => {
      emits("market-selection", selected.value);
    };
    watch(storeData, () => {
      var _a, _b;
      selected.value = (_b = (_a = storeData.value) == null ? void 0 : _a.find((market) => market.id === props.id)) != null ? _b : null;
    });
    return { __sfc: true, props, emits, selected, marketSelectorId, isSelectDisabled, componentInputs, localizationSupport, translate, textFormat, storeModule, storeData, isLoadingStoreData, onMarketChange };
  }
});

export { _sfc_main as default };
